import type { MassLifecycleSummary } from '@/types/domain';
import { cn } from '@/utils/cn';

interface MassLifecycleBadgeProps {
  summary: MassLifecycleSummary;
}

export function MassLifecycleBadge({ summary }: MassLifecycleBadgeProps): JSX.Element {
  return (
    <span className={cn('mass-lifecycle-badge', `mass-lifecycle-badge--${summary.tone}`)}>
      <span className="mass-lifecycle-badge__dot" aria-hidden="true" />
      {summary.label}
    </span>
  );
}
